import * as React from 'react';
import { Typography, Container, Paper } from "@material-ui/core";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import {useEffect} from "react";
import Loader from "react-loader-spinner";

export default function FormSubmitted({ handleSubmit, submitSuccess, referenceNumber }) {
  useEffect(() => {
    window.scrollTo(0, 0);
    handleSubmit();
  }, []);

  return (
    <Container maxWidth="sm" style={{ textAlign: "center", marginTop: "16px" }}>
      <Paper elevation={0} style={{ padding: "40px", borderRadius: "10px" }}>
        {submitSuccess === null ? (
          <div>
            <Typography variant="h6">Submitting your response...</Typography>
            <Loader type="ThreeDots" color="#124e90" height="60" width="60" />
          </div>

        ) : submitSuccess === true ? (
          <>
            <CheckCircleIcon style={{ fontSize: 80, color: "green" }} />
            <Typography variant="h5" style={{ fontWeight: "bold", marginTop: "8px" }}>
              Response Submitted Successfully!
            </Typography>
            <Typography variant="body1" style={{ marginTop: "32px", color: "#555", textAlign: 'left'}}>
              Thank you for submitting the form. Your request has been received.
            </Typography>
            {referenceNumber && (
              <div style={{ marginTop: "10px", color: "#333", textAlign: 'left'}}>
                <Typography variant="body1">
                  Now that you've completed the form, enjoy a little well-earned humor: <br/><br/>
                </Typography>
                <Typography variant="h6" style={{ fontWeight: "bold"}}>
                  {referenceNumber}
                </Typography>
              </div>

            )}
          </>
        ) : (
          <>
            <Typography variant="h5" style={{ color: "red", fontWeight: "bold" }}>
              Submission Failed
            </Typography>
            <Typography variant="body1" style={{ marginTop: "10px", color: "#555" }}>
              Please try again later or contact support.
            </Typography>
          </>
        )}
      </Paper>
    </Container>
  );
}
